module.exports = __webpack_public_path__ + "static/media/help_clauses.5b22800c.png";